import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const engagements = [
  { key: 'clean', icon: 'ri-leaf-line' },
  { key: 'expertise', icon: 'ri-award-line' },
  { key: 'custom', icon: 'ri-heart-pulse-line' },
  { key: 'wellness', icon: 'ri-heart-3-line' },
];

export default function EngagementsSection() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const elements = entry.target.querySelectorAll('.reveal-item');
            elements.forEach((el, i) => {
              setTimeout(() => { el.classList.add('visible'); }, i * 120);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full py-16 md:py-24 bg-primary-50/30">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4 tracking-wider uppercase">
            Nos valeurs
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-800 mb-4">
            {t('engagements.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('engagements.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-6xl mx-auto">
          {engagements.map((item) => (
            <div
              key={item.key}
              className="reveal-item opacity-0 translate-y-6 transition-all duration-700 group"
              style={{ transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)' }}
            >
              <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center border border-background-200/60 hover:border-primary-300/70 transition-all duration-500 group-hover:-translate-y-1.5 group-hover:shadow-lg">
                <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-50 group-hover:bg-primary-500 transition-colors duration-500">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-500`} />
                  </div>
                </div>
                <h3 className="font-heading text-xl text-foreground-800 mb-2">
                  {t(`engagements.${item.key}.title`)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t(`engagements.${item.key}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}